import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import * as Sentry from "@sentry/react";

import "./index.css";
import { HTTPError } from "./common/helpers/http.ts";
import { isProductionEnvironment } from "./common/helpers/utils.ts";
import { ToastContainer } from "react-toastify";
import Report from "./pages/report/Report.tsx";
import LandingPage from "./pages/landing/LandingPage.tsx";
import TermsOfService from "./pages/tos/TermsOfService.tsx";
import PrivacyPolicy from "./pages/privacy/PrivacyPolicy.tsx";
import TokenGuard from "./components/TokenGuard.tsx";
import ScrollToTop from "./components/ScrollToTop.tsx";

if (isProductionEnvironment()) {
  Sentry.init({
    environment: import.meta.env.MODE,
    dsn: "https://b167d37fe3a1f01b695e6acd874de14f@o769987.ingest.us.sentry.io/4508460489310209",
    release: import.meta.env.VITE_SENTRY_RELEASE,
    beforeSend(event, hint) {
      // we don't send fetch errors
      if (hint.originalException instanceof HTTPError) {
        return null;
      }
      return event;
    },
  });
}

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <BrowserRouter>
      <ScrollToTop />
      <Routes>
        <Route index element={<TokenGuard />} />
        <Route path="report" element={<Report />} />
        <Route path="landing" element={<LandingPage />} />
        <Route path="tos" element={<TermsOfService />} />
        <Route path="privacy" element={<PrivacyPolicy />} />
      </Routes>
    </BrowserRouter>
    <ToastContainer />
  </StrictMode>
);
